// @ts-nocheck
import angular from "angular"
import { $unibase } from "../uni-base-module"
import * as _ from "lodash"

export interface SimpleStoreFactory {
  new(key: string): SimpleStore
}

export class SimpleStore {
  private keyprop: string
  list: any[]
  map: any

  constructor(
    key: string,
    private $log,
    private localStorageService,
    private UniConfig
  ) {
    this.keyprop = key
  }

  load(list, keyby) {
    this.$log.debug("Inicializando lista", list)

    this.list = list

    // si se  pasa un keyby, hacer un dict de los datos
    if (keyby) {
      this.map = _.keyBy(list, keyby)
    }
  }

  eliminar(id) {
    // buscar en la lista el id y eliminar
    this.$log.debug("Eliminando id ", id)

    var idx = _.findIndex(this.list, [this.keyprop, id])

    if (idx < 0) {
      this.$log.info("** No encontrado índice para " + id)
    } else {
      this.$log.debug("idx en lista ", idx)
      this.list.splice(idx, 1)
    }
  }

  nuevo(object) {
    this.$log.debug("Nuevo modelo", object)

    // if (angular.isDefined (idx)) {}

    this.list.push(object)
  }

  actualizar(object) {
    this.$log.debug("Actualizando modelo : ", object)

    var objkey = object[this.keyprop]

    if (objkey === null || angular.isUndefined(objkey)) {
      this.$log.info(
        "** No encontrado valor en objeto para actualizar " + object
      )
    } else {
      var obj = _.find(this.list, [this.keyprop, objkey])

      if (angular.isUndefined(obj)) {
        // se trata como un nuevo elemento del store
        this.$log.info(
          "** No encontrado objeto para key, se trata como nuevo  ",
          objkey
        )

        // añadir elemento a la lista
        this.list.push(object)

        // añadir al map de objetos si está definido el map y se clasifica por key
        if (this.keyprop && this.map) {
          this.map[object[this.keyprop]] = object
        }
      } else {
        this.$log.debug("Actualizando ", obj)

        angular.merge(obj, object)
      }
    }
  }
}

$unibase.factory("SimpleStore", [
  "$log",
  "localStorageService",
  "UniConfig",
  ($log, localStorageService, UniConfig) => (key: string) =>
    new SimpleStore(key, $log, localStorageService, UniConfig)
])
